import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import http from '@/utils/http';
import { ElLoading } from 'element-plus';
import { message } from '@/utils/restMessage.js'; // 引入wxjs

import wx from "weixin-js-sdk";
export default {
  data: function data() {
    return {
      bwidth: true,
      //表单宽度
      phoneShow: true,
      //二维码状态
      imgStatus: false,
      //图片状态
      titleSize: 24,
      //标题大小
      mainpadding: 20,
      //整体边距
      radioShow: false,
      radio: false,
      //单选按钮
      shData2: ['湿法清洗（水基清洗、化学溶剂清洗等）', '干冰清洗', '等离子清洗', '超声波清洗', '手工擦拭清洗'],
      //第2题
      shData3: ['金属制品', '塑料制品', '电子元器件', '玻璃制品'],
      //第3题多选
      shData5: ['清洗效果不理想（有残留污渍等）', '清洗效率低，耗时过长', '清洗成本过高（包括设备、耗材、人力等）', '清洗过程对产品有损伤', '环保问题（废水、废气处理困难）', '粘接力问题'],
      //第5题
      shData6: ['粘接预处理', '喷涂预处理', '焊接预处理', '涂覆预处理', '点胶预处理'],
      //第6题
      shData8: ['清洗温度控制问题', '静电太高无法控制', '设备维护复杂且频繁', '清洗效果不稳定，一致性差', '飞件解决方案', '掉件解决方案', '操作人员培训难度大，技能要求高', '与现有生产线兼容性差，集成度低'],
      //第9题
      shData9: ['技术实力和研发能力', '产品质量和可靠性', '清洗设备的价格和性价比', '售后服务和技术支持', '品牌知名度和行业口碑'],
      shData10: ['提高产品清洁度与纯度', '减少缺陷率与不良品率', '提升生产效率与节拍', '延长生产设备与部件的寿命', '符合环保与合规性要求', '显著提升清洗效果', '大幅降低清洗成本', '实现自动化清洗，减少人力投入', '确保清洗过程的稳定性和可靠性'],
      dx: {
        //多选
        multiplechoice1: [],
        //第一题多选
        multiplechoice2: [],
        //第七题多选
        multiplechoice3: [],
        //第八题多选
        multiplechoice4: [],
        //第九题多选
        multiplechoice5: [],
        //第一题多选
        multiplechoice6: [],
        //第七题多选
        multiplechoice7: [],
        //第八题多选
        multiplechoice8: [] //第八题多选

      },
      tk: {
        suggestions1: '',
        //填空1
        suggestions2: '',
        //填空2
        suggestions3: '',
        //填空3
        suggestions4: '',
        //填空4
        suggestions5: '',
        //填空5
        suggestions6: '',
        //填空6
        suggestions7: '',
        //填空7
        suggestions8: '',
        //填空8
        suggestions9: '',
        //填空8
        suggestions10: '',
        //填空8
        suggestions11: '' //填空8

      },
      // 单选四题
      singlechoice1: '',
      singlechoice2: '',
      singlechoice3: '',
      singlechoice4: '',
      bus: {
        type: 4,
        //工业清洗调查表
        company: '',
        //公司
        email: '',
        //邮箱
        contact: '',
        //联系人
        position: '',
        //职务
        phone: '',
        //联系电话
        multiplechoice1: '',
        //第一题多选
        multiplechoice2: '',
        //第七题多选
        multiplechoice3: '',
        //第八题多选
        multiplechoice4: '',
        //第九题多选
        multiplechoice5: '',
        //第七题多选
        multiplechoice6: '',
        //第八题多选
        multiplechoice7: '',
        //第九题多选
        singlechoice1: '',
        singlechoice2: '',
        singlechoice3: '',
        singlechoice4: '',
        singlechoice5: '',
        singlechoice6: ''
      },
      rcmklog: {
        ip: '',
        iparea: '',
        mac: '',
        description: 'RCMK调查问卷'
      },
      qyData: [{
        name: "北京",
        selected: false,
        value: 1,
        lowercaseName: "beijing"
      }, {
        name: "天津",
        selected: false,
        value: 2,
        lowercaseName: "tianjin"
      }, {
        name: "上海",
        selected: false,
        value: 3,
        lowercaseName: "shanghai"
      }, {
        name: "重庆",
        selected: false,
        value: 4,
        lowercaseName: "chongqing"
      }, {
        name: "河北",
        selected: false,
        value: 5,
        lowercaseName: "hebei"
      }, {
        name: "河南",
        selected: false,
        value: 6,
        lowercaseName: "henan"
      }, {
        name: "云南",
        selected: false,
        value: 7,
        lowercaseName: "yunnan"
      }, {
        name: "辽宁",
        selected: false,
        value: 8,
        lowercaseName: "liaoning"
      }, {
        name: "黑龙江",
        selected: false,
        value: 9,
        lowercaseName: "heilongjiang"
      }, {
        name: "湖南",
        selected: false,
        value: 10,
        lowercaseName: "hunan"
      }, {
        name: "安徽",
        selected: false,
        value: 11,
        lowercaseName: "anhui"
      }, {
        name: "山东",
        selected: false,
        value: 12,
        lowercaseName: "shandong"
      }, {
        name: "新疆",
        selected: false,
        value: 13,
        lowercaseName: "xinjiang"
      }, {
        name: "江苏",
        selected: false,
        value: 14,
        lowercaseName: "jiangsu"
      }, {
        name: "浙江",
        selected: false,
        value: 15,
        lowercaseName: "zhejiang"
      }, {
        name: "江西",
        selected: false,
        value: 16,
        lowercaseName: "jiangxi"
      }, {
        name: "湖北",
        selected: false,
        value: 17,
        lowercaseName: "hubei"
      }, {
        name: "广西",
        selected: false,
        value: 18,
        lowercaseName: "guangxi"
      }, {
        name: "甘肃",
        selected: false,
        value: 19,
        lowercaseName: "gansu"
      }, {
        name: "山西",
        selected: false,
        value: 20,
        lowercaseName: "shanxi"
      }, {
        name: "内蒙古",
        selected: false,
        value: 21,
        lowercaseName: "neimenggu"
      }, {
        name: "陕西",
        selected: false,
        value: 22,
        lowercaseName: "shanxi"
      }, {
        name: "吉林",
        selected: false,
        value: 23,
        lowercaseName: "jilin"
      }, {
        name: "福建",
        selected: false,
        value: 24,
        lowercaseName: "fujian"
      }, {
        name: "贵州",
        selected: false,
        value: 25,
        lowercaseName: "guizhou"
      }, {
        name: "广东",
        selected: false,
        value: 26,
        lowercaseName: "guangdong"
      }, {
        name: "青海",
        selected: false,
        value: 27,
        lowercaseName: "qinghai"
      }, {
        name: "西藏",
        selected: false,
        value: 28,
        lowercaseName: "xizang"
      }, {
        name: "四川",
        selected: false,
        value: 29,
        lowercaseName: "sichuan"
      }, {
        name: "宁夏",
        selected: false,
        value: 30,
        lowercaseName: "ningxia"
      }, {
        name: "海南",
        selected: false,
        value: 31,
        lowercaseName: "hainan"
      }, {
        name: "台湾",
        selected: false,
        value: 32,
        lowercaseName: "taiwan"
      }, {
        name: "香港",
        selected: false,
        value: 33,
        lowercaseName: "hongkong"
      }, {
        name: "澳门",
        selected: false,
        value: 34,
        lowercaseName: "macau"
      }]
    };
  },
  created: function created() {
    // console.log(navigator.userAgent,'电脑信息');
    if (window.screen.availWidth < 800) {
      //判断屏幕小于800时
      console.log('手机端');
      this.titleSize = 17;
      this.mainpadding = 0;
      this.bwidth = false;
      this.phoneShow = false;
    }
  },
  methods: {
    // 判断是否勾选了其它
    xz1: function xz1(e) {
      if (e == false) {
        this.tk.suggestions1 = '';
      }
    },
    xz2: function xz2(e) {
      console.log(e);

      if (e != '其它') {
        this.tk.suggestions2 = '';
      }
    },
    xz3: function xz3(e) {
      if (e == false) {
        this.tk.suggestions3 = '';
      }
    },
    xz4: function xz4(e) {
      if (e != '其它') {
        this.tk.suggestions4 = '';
      }
    },
    xz5: function xz5(e) {
      if (e == false) {
        this.tk.suggestions5 = '';
      }
    },
    xz6: function xz6(e) {
      if (e == false) {
        this.tk.suggestions6 = '';
      }
    },
    xz7: function xz7(e) {
      if (e != '其它') {
        this.tk.suggestions7 = '';
      }
    },
    xz8: function xz8(e) {
      if (e == false) {
        this.tk.suggestions8 = '';
      }
    },
    xz9: function xz9(e) {
      if (e != '其它') {
        this.tk.suggestions9 = '';
      }
    },
    xz10: function xz10(e) {
      if (e == false) {
        this.tk.suggestions10 = '';
      }
    },
    xz11: function xz11(e) {
      if (e == false) {
        this.tk.suggestions11 = '';
      }
    },
    // 判断填空1是否有勾选其它
    tk1: function tk1() {
      var sun = true;
      this.bus.singlechoice1.map(function (v) {
        if (v == '其它') {
          sun = false;
        }
      });
      return sun;
    },
    // 判断填空2是否有勾选其它
    tk2: function tk2() {
      var sun = true;
      this.dx.multiplechoice1.map(function (v) {
        if (v == '其它') {
          sun = false;
        }
      });
      return sun;
    },
    // 判断填空3是否有勾选其它
    tk3: function tk3() {
      var sun = true;
      this.dx.multiplechoice2.map(function (v) {
        if (v == '其它') {
          sun = false;
        }
      });
      return sun;
    },
    // 判断填空4是否有勾选其它
    tk4: function tk4() {
      var sun = true;
      this.dx.multiplechoice3.map(function (v) {
        if (v == '其它') {
          sun = false;
        }
      });
      return sun;
    },
    // 判断填空4是否有勾选其它
    tk5: function tk5() {
      var sun = true;
      this.dx.multiplechoice3.map(function (v) {
        if (v == '其它') {
          sun = false;
        }
      });
      return sun;
    },
    // 判断填空4是否有勾选其它
    tk6: function tk6() {
      var sun = true;
      this.dx.multiplechoice4.map(function (v) {
        if (v == '其它') {
          sun = false;
        }
      });
      return sun;
    },
    // 判断填空4是否有勾选其它
    tk7: function tk7() {
      var sun = true;
      this.dx.multiplechoice5.map(function (v) {
        if (v == '其它') {
          sun = false;
        }
      });
      return sun;
    },
    // 判断填空4是否有勾选其它
    tk8: function tk8() {
      var sun = true;
      this.dx.multiplechoice5.map(function (v) {
        if (v == '其它') {
          sun = false;
        }
      });
      return sun;
    },
    // 判断填空4是否有勾选其它
    tk9: function tk9() {
      var sun = true;
      this.dx.multiplechoice6.map(function (v) {
        if (v == '其它') {
          sun = false;
        }
      });
      return sun;
    },
    // 判断填空4是否有勾选其它
    tk10: function tk10() {
      var sun = true;
      this.dx.multiplechoice6.map(function (v) {
        if (v == '其它') {
          sun = false;
        }
      });
      return sun;
    },
    // 判断填空4是否有勾选其它
    tk11: function tk11() {
      var sun = true;
      this.dx.multiplechoice7.map(function (v) {
        if (v == '其它') {
          sun = false;
        }
      });
      return sun;
    },
    // 点击显示图片
    tuShow: function tuShow() {
      this.imgStatus = true;
    },
    // 验证规则
    srule: function srule() {
      var singlechoice1 = this.singlechoice1,
          singlechoice2 = this.singlechoice2,
          singlechoice3 = this.singlechoice3,
          singlechoice4 = this.singlechoice4;
      var _this$bus = this.bus,
          company = _this$bus.company,
          email = _this$bus.email,
          contact = _this$bus.contact,
          position = _this$bus.position,
          phone = _this$bus.phone,
          singlechoice5 = _this$bus.singlechoice5; // 公司名称

      if (company == '') {
        message({
          type: "error",
          message: '公司名称不能为空'
        });
        return false;
      } // 联系人


      if (contact == '') {
        message({
          type: "error",
          message: '联系人不能为空'
        });
        return false;
      } // 电话


      if (phone == '') {
        message({
          type: "error",
          message: '电话不能为空'
        });
        return false;
      } // 职位


      if (position == '') {
        message({
          type: "error",
          message: '职位不能为空'
        });
        return false;
      } // 邮箱


      if (email == '') {
        message({
          type: "error",
          message: '邮箱不能为空'
        });
        return false;
      } // 第1题


      if (singlechoice1 == '') {
        message({
          type: "error",
          message: '第1题不能为空'
        });
        return false;
      } // 第2题


      if (this.dx.multiplechoice1.length == 0) {
        message({
          type: "error",
          message: '第2题不能为空'
        });
        return false;
      } // 第3题


      if (this.dx.multiplechoice2.length == 0) {
        message({
          type: "error",
          message: '第3题不能为空'
        });
        return false;
      } // 第4题


      if (singlechoice2 == '') {
        message({
          type: "error",
          message: '第4题不能为空'
        });
        return false;
      } // 第5题


      if (this.dx.multiplechoice3.length == 0) {
        message({
          type: "error",
          message: '第5题不能为空'
        });
        return false;
      } // 第6题


      if (this.dx.multiplechoice4.length == 0) {
        message({
          type: "error",
          message: '第6题不能为空'
        });
        return false;
      } // 第7题


      if (singlechoice3 == '') {
        message({
          type: "error",
          message: '第7题不能为空'
        });
        return false;
      }

      if (singlechoice3 != '了解一些基本原理和应用' && singlechoice3 != '') {
        // 第8题
        if (singlechoice4 == '') {
          message({
            type: "error",
            message: '第8题不能为空'
          });
          return false;
        }
      } else {
        // 第8题
        if (this.dx.multiplechoice5.length == 0) {
          message({
            type: "error",
            message: '第8题不能为空'
          });
          return false;
        }
      } // 第9题


      if (this.dx.multiplechoice6.length == 0) {
        message({
          type: "error",
          message: '第9题不能为空'
        });
        return false;
      } // 第10题


      if (this.dx.multiplechoice7.length == 0) {
        message({
          type: "error",
          message: '第10题不能为空'
        });
        return false;
      } // 第11题


      if (singlechoice5 === '') {
        message({
          type: "error",
          message: '第11题不能为空'
        });
        return false;
      }

      return true;
    },
    duoxuan: function duoxuan() {
      var _this = this;

      if (this.singlechoice1 == '其它') {
        this.bus.singlechoice1 = this.singlechoice1 + '-' + this.tk.suggestions1;
      }

      if (this.singlechoice2 == '其它') {
        this.bus.singlechoice2 = this.singlechoice2 + '-' + this.tk.suggestions4;
      }

      if (this.singlechoice3 == '非常了解，使用设备品牌') {
        this.bus.singlechoice3 = this.singlechoice3 + '-' + this.tk.suggestions7;
      }

      if (this.singlechoice4 == '绝对不会考虑，有其他顾虑（请注明）') {
        this.bus.singlechoice4 = this.singlechoice4 + '-' + this.tk.suggestions9;
      }

      this.dx.multiplechoice1.map(function (v, i) {
        if (v == '其它') {
          _this.dx.multiplechoice1[i] = v + '-' + _this.tk.suggestions2;
        }
      });
      this.dx.multiplechoice2.map(function (v, i) {
        if (v == '其它') {
          _this.dx.multiplechoice2[i] = v + '-' + _this.tk.suggestions3;
        }
      });
      this.dx.multiplechoice3.map(function (v, i) {
        if (v == '其它') {
          _this.dx.multiplechoice3[i] = v + '-' + _this.tk.suggestions5;
        }
      });
      this.dx.multiplechoice4.map(function (v, i) {
        if (v == '其它') {
          _this.dx.multiplechoice4[i] = v + '-' + _this.tk.suggestions6;
        }
      });
      this.dx.multiplechoice5.map(function (v, i) {
        if (v == '其它') {
          _this.dx.multiplechoice5[i] = v + '-' + _this.tk.suggestions8;
        }
      });
      this.dx.multiplechoice6.map(function (v, i) {
        if (v == '其它') {
          _this.dx.multiplechoice6[i] = v + '-' + _this.tk.suggestions10;
        }
      });
      this.dx.multiplechoice7.map(function (v, i) {
        if (v == '其它') {
          _this.dx.multiplechoice7[i] = v + '-' + _this.tk.suggestions11;
        }
      });
    },
    // 点击提交
    busAdd: function busAdd() {
      var _this2 = this;

      if (!this.srule()) {
        return false;
      }

      this.duoxuan();
      this.bus.multiplechoice1 = this.dx.multiplechoice1.join('，');
      this.bus.multiplechoice2 = this.dx.multiplechoice2.join('，');
      this.bus.multiplechoice3 = this.dx.multiplechoice3.join('，');
      this.bus.multiplechoice4 = this.dx.multiplechoice4.join('，');
      this.bus.multiplechoice5 = this.dx.multiplechoice5.join('，');
      this.bus.multiplechoice6 = this.dx.multiplechoice6.join('，');
      this.bus.multiplechoice7 = this.dx.multiplechoice7.join('，'); // 遮罩层

      var loading = ElLoading.service({
        lock: true,
        text: '提交中...',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      http.post("/ksfcustomersurvey3/save", this.bus).then(function (res) {
        var _res$data = res.data,
            code = _res$data.code,
            description = _res$data.description;
        console.log(res);

        if (200 == code) {
          loading.close();
          message({
            type: "success",
            message: '提交成功！'
          });
          setTimeout(function () {
            _this2.imgStatus = true;
          }, 500); //成功后清空数据

          for (var key in _this2.bus) {
            _this2.bus[key] = '';
          }

          for (var _key in _this2.tk) {
            _this2.tk[_key] = '';
          }

          for (var _key2 in _this2.dx) {
            _this2.dx[_key2] = [];
          }

          _this2.singlechoice1 = '';
          _this2.singlechoice2 = '';
          _this2.singlechoice3 = '';
          _this2.singlechoice4 = '';
          _this2.bus.type = 4;
        } else {
          loading.close();

          for (var _key3 in _this2.bus) {
            _this2.bus[_key3] = '';
          }

          _this2.bus.type = 4;
          _this2.singlechoice1 = '';
          _this2.singlechoice2 = '';
          _this2.singlechoice3 = '';
          _this2.singlechoice4 = '';

          for (var _key4 in _this2.tk) {
            _this2.tk[_key4] = '';
          }

          for (var _key5 in _this2.dx) {
            _this2.dx[_key5] = [];
          }

          message({
            type: "error",
            message: description
          });
        }
      }).catch(function (err) {
        for (var key in _this2.bus) {
          _this2.bus[key] = '';
        }

        _this2.bus.type = 4;
        _this2.singlechoice1 = '';
        _this2.singlechoice2 = '';
        _this2.singlechoice3 = '';
        _this2.singlechoice4 = '';

        for (var _key6 in _this2.tk) {
          _this2.tk[_key6] = '';
        }

        for (var _key7 in _this2.dx) {
          _this2.dx[_key7] = [];
        }

        message({
          type: "error",
          message: '服务器错误，请联系管理员'
        });
      });
    }
  }
};